module.exports = __webpack_public_path__ + "static/media/tyre-yellow-two1.67f33067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-two1.png
// module id = 351
// module chunks = 0